import { RoadmapItemDto } from "../../../../../customer-experience/src/lib/ShiOneClient";
import { recommendationRegistry } from "../recommendations";
import { initialRoadmapItemState } from "./roadmapProps";
import { taskStatusOptions } from "./constants";

interface CreateTaskContext {
  roadmapId: string;
  parentRoadmapItemId: string;
  initiativeTasks: RoadmapItemDto[];
  index: number;
}

interface CreateTaskOptions {
  recommendation: any;
  context: CreateTaskContext;
}

export function createRoadmapTaskFromRecommendation({
  recommendation,
  context,
}: CreateTaskOptions): RoadmapItemDto | null {
  const handler =
    recommendationRegistry.getHandlerForRecommendation(recommendation);

  if (!handler) {
    console.warn("No handler found for recommendation:", recommendation);
    return null;
  }

  const adapter = handler.adapter;
  const metadata = handler.createMetadata(recommendation);

  // Get the recommendation ID (GUID) if available
  // This should be the AggregatedRecommendation.Id from the backend
  const recommendationId =
    (recommendation as any).recommendationId || undefined;

  return RoadmapItemDto.fromJS({
    ...initialRoadmapItemState,
    roadmapId: context.roadmapId,
    parentRoadmapItemId: context.parentRoadmapItemId,
    roadmapItemOrdinal: context.initiativeTasks.length + context.index,
    roadmapItemId: crypto.randomUUID(),
    name: adapter.getTitle(recommendation),
    description: adapter.getDescription(recommendation),
    status: taskStatusOptions[0],
    sourceType: handler.sourceType,
    sourceId: adapter.getSourceId(recommendation),
    sourceMetadata: metadata,
    recommendationId: recommendationId,
  });
}
